import RevenueSharingSettingsPage from "./revenueSharingSettings";

export default RevenueSharingSettingsPage;